import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "../lib/api";

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function monthLabel(ym) {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
}

function shift(ym, delta) {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/**
 * Month filter: arrows to step month by month, plus a dropdown of the last
 * 12 months and any older months that have cricket activity.
 */
export default function MonthSelect({ value, onChange, activeMonths = [], dark = false, testid = "month-select" }) {
  const now = currentMonth();
  const recent = Array.from({ length: 12 }, (_, i) => shift(now, -i));
  const options = Array.from(new Set([...recent, ...activeMonths, value])).sort().reverse();
  const active = new Set(activeMonths);

  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      <button
        type="button"
        onClick={() => onChange(shift(value, -1))}
        className={cn("h-9 w-9 rounded-xl grid place-items-center", dark ? "hover:bg-white/10" : "hover:bg-black/5")}
        aria-label="Previous month"
      >
        <ChevronLeft size={18} />
      </button>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn("h-9 px-2 rounded-xl text-sm font-semibold outline-none", dark ? "bg-white/10 text-white" : "bg-black/[0.04]")}
        aria-label="Month"
      >
        {options.map((m) => (
          <option key={m} value={m} className="text-ink">
            {monthLabel(m)}{active.has(m) ? " •" : ""}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={() => onChange(shift(value, 1))}
        disabled={value >= now}
        className={cn("h-9 w-9 rounded-xl grid place-items-center disabled:opacity-30", dark ? "hover:bg-white/10" : "hover:bg-black/5")}
        aria-label="Next month"
      >
        <ChevronRight size={18} />
      </button>
    </div>
  );
}
